import React from "react";
import Header from "../../../commons/Header/Header";
import Footer from "../../../commons/Footer/Footer";
import "./PrivacyPolicyFr.css";

const PrivacyPolicyFr = (props) => {
  return (
    <>
    <Header en="/privacy-policy" fr="/politique-de-confidentialite" lang="fr" />
    <div className="container mainDiv ab">
      <div className="row">
        <div className="col-xs-12 content">
          <h1 className="privacy-policy">Politique de confidentialité</h1>
          <div>
            <ol className="tlprivacypolicy">
              <li>
                <h2>Introduction</h2>
                <p>Travelance Inc (« nous », « notre », « nos ») respecte votre vie privée et s’engage à protéger vos renseignements personnels. Cette politique de confidentialité décrit comment nous recueillons, utilisons, divulguons et protégeons vos données conformément aux lois canadiennes sur la protection des renseignements personnels (LPRPDE et LPVPC) et au Règlement général sur la protection des données (RGPD) de l’UE, le cas échéant.</p>
                <p>En utilisant <a class="c3" href="https://www.travelance.ca/fr">travelance.ca</a>, le portail Quote (quote.travelance.ca), le portail web MyTL (mytl.travelance.ca) ou tout autre service fourni par Travelance Inc., vous consentez aux pratiques décrites dans la présente politique de confidentialité.</p>
              </li>
              <li>
                <h2>Informations que nous collectons</h2>
                <p>Nous collectons les types d’informations personnelles et non personnelles suivants:</p>
                <ul>
                  <li>Informations personnelles : Nom complet, coordonnées (email, téléphone, adresse), informations de paiement, détails du voyage, questions médicales, adresse IP.</li>
                  <li>Informations techniques : Type de navigateur, identifiants de l’appareil, cookies, temps d’accès et URL de référence.</li>
                  <li>Données d’utilisation : Pages visitées, liens cliqués, temps passé sur le site.</li>
                </ul>
              </li>
              <li>
                <h2>Comment nous utilisons vos informations</h2>
                <p>Nous utilisons vos données pour :</p>
                <ul>
                  <li>Traiter les devis et demandes d’assurance</li>
                  <li>Fournir un support client</li>
                  <li>Personnalisez votre expérience sur notre site web</li>
                  <li>Prévenir la fraude et assurer la sécurité</li>
                  <li>Se conformer aux obligations légales et réglementaires</li>
                  <li>Envoyer des communications marketing (uniquement avec votre consentement explicite)</li>
                </ul>
              </li>
              <li>
                <h2>Base juridique du traitement (RGPD)</h2>
                <p>Nous traitons vos données personnelles sur une ou plusieurs des bases légales suivantes:</p>
                <ul>
                    <li>Votre consentement</li>
                    <li>Pour remplir une obligation contractuelle</li>
                    <li>Pour nos intérêts légitimes, à condition qu’ils ne prévalent pas sur vos droits</li>
                    <li>Respect d’une obligation légale</li>
                </ul>
              </li>
              <li>
                <h2>Partage de données et tiers</h2>
                <p>Nous pouvons partager vos informations avec:</p>
                <ul>
                    <li>Sociétés affiliées et filiales sous propriété commune</li>
                    <li>Prestataires de services tiers pour le traitement des paiements, la livraison des e-mails, l’analyse et l’hébergement</li>
                    <li>Autorités légales lorsque la loi l’exige ou pour protéger nos intérêts juridiques</li>
                    <li>Partenaires commerciaux si nous faisons une fusion, une acquisition ou une vente d’actifs (avec avis utilisateur)</li>
                </ul>
                <p>Chaque tiers est contractuellement tenu d’utiliser vos données uniquement selon les instructions de Travelance Inc.</p>
              </li>
              <li>
                <h2>Transferts de données internationaux</h2>
                <p>Si des données sont transférées à l’extérieur du Canada, nous veillons à ce qu’elles soient protégées par des clauses contractuelles standard (SCC) ou des garanties équivalentes.</p>
              </li>
              <li>
                <h2>Conservation des données</h2>
                <p>Nous ne conservons les informations personnelles qu’aussi longtemps que nécessaire aux fins indiquées ou tel que requis par la loi. Lorsqu’elles ne sont plus nécessaires, vos données seront supprimées ou anonymisées en toute sécurité.</p>
              </li>
              <li>
                <h2>Vos droits</h2>
                <p>Vous avez le droit de:</p>
                <ul class="c13 lst-kix_p1c5qpgikcyu-0 start">
                    <li>Accéder aux données personnelles que nous détenons à votre sujet</li>
                    <li>Corriger les données inexactes ou obsolètes</li>
                    <li>Demander la suppression de vos données (sous réserve des obligations légales)</li>
                    <li>Objecter ou restreindre le traitement dans certaines situations</li>
                    <li>Retirer son consentement à tout moment (pour les données traitées sur la base du consentement)</li>
                    <li>Demander la portabilité des données dans un format lisible par machine</li>
                </ul>
                <p>Pour exercer l’un de ces droits, envoyez-nous un courriel à: <a href="mailto:admin@travelance.ca">admin@travelance.ca</a>.</p>
              </li>
              <li>
                <h2>Cookies et suivi</h2>
                <p>Travelance Inc. utilise des cookies et des technologies similaires pour personnaliser votre expérience et analyser le trafic. Vous serez invité à accepter ou refuser les cookies non essentiels lorsque vous visitez notre site.</p>
                <p>Pour plus de détails sur notre utilisation des cookies, veuillez consulter la section Cookies dans nos <a href="/modalites-et-conditions">Conditions générales</a>.</p>
              </li>
              <li>
                <h2>Sécurité des données</h2>
                <p>Nous employons des mesures techniques et organisationnelles conformes aux normes de l’industrie, y compris le cryptage, les pare-feu, les contrôles d’accès sécurisés et les systèmes de détection d’intrusion, pour protéger vos informations.</p>
              </li>
              <li>
                <h2>Notification de violation de données</h2>
                <p>En cas de violation de données, nous informerons les utilisateurs et les régulateurs concernés dans le délai légalement requis, conformément aux réglementations CPPA ou RGPD.</p>
              </li>
              <li>
                <h2>Vie privée des enfants</h2>
                <p>Travelance Inc. ne collecte pas sciemment des données sur les enfants de moins de 13 ans. Si nous apprenons que nous avons collecté ces données sans le consentement parental, nous les supprimerons rapidement.</p>
              </li>
              <li>
                <h2>S’applique à</h2>
                <p>Cette politique de confidentialité s’applique à toutes les personnes dont les informations personnelles sont collectées, traitées ou stockées par Travelance Inc., y compris les utilisateurs de notre site Web et des services connexes.</p>
              </li>
              <li>
                <h2>Modifications à la présente politique</h2>
                <p>Nous pouvons mettre à jour cette politique de confidentialité périodiquement. Lorsque nous le ferons, nous réviserons la « date d’entrée en vigueur » indiquée au bas de ce document et fournirons un avis via notre site Web. L’utilisation continue de nos services implique le consentement aux conditions mises à jour.</p>
              </li>
              <li>
                <h2>Contactez-nous</h2>
                <p>Si vous avez des questions concernant cette politique de confidentialité, veuillez nous contacter en utilisant ce formulaire: <a href="/contactez-nous">www.travelance.ca/contactez-nous/</a> ou par email à <a href="mailto:admin@travelance.ca">admin@travelance.ca</a></p>
              </li>
            </ol>
            <p><b>Date d’entrée en vigueur</b>: 02 juillet 2013</p>
            <p><b>Dernière mise à jour</b>: 27 mai 2025</p>
          </div>
        </div>
      </div>
    </div>
    <Footer lang="fr" />
    </>
  );
}

export default PrivacyPolicyFr;
